/**
 * ScrollToTop — router-aware scroll-to-top side effect.
 *
 * Mount once at the marketing-website router root. Whenever the path
 * changes (but NOT when only the hash changes — anchor links inside
 * long pages should scroll to the anchor, not the top), scroll the
 * window to (0, 0).
 *
 * Skips on initial mount so deep-link anchors + browser-restored
 * scroll positions are respected.
 *
 * @module @puffin-core/marketing-shell/ScrollToTop
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * @returns {null} Emits no DOM; effect-only.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const initialMount = useRef(true);

  useEffect(() => {
    if (initialMount.current) {
      initialMount.current = false;
      return;
    }
    if (typeof window !== 'undefined' && typeof window.scrollTo === 'function') {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  }, [pathname]);

  return null;
}
